import { Row, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import React from "react";
import walletLogo from "./img/roro-wallet.png";
import { connect } from "react-redux";
import { selectWalletBalance } from "store/user/reducer";
import Currency from "components/Currency";

function PaymentCard(props) {
    const { paymentGateway, paymentClick, walletBalance } = props;

    function getBankGatewayCard() {
        return <Row className='payment-row py-1' onClick={(e) => paymentClick(e)}>
            <div className="payment-row-right">
                <img className='ml-1 payment-logo' src={paymentGateway.imageUrl} alt="" />
                <div>
                    <Typography level={4} className='f-22  mt-0'> {'پرداخت ' + paymentGateway.displayName}</Typography>
                    <Typography level={5}
                        className='f-14  mt-0 color-primary'> {'پرداخت با تمامی کارتهای عضو شتاب'}</Typography>
                </div>
            </div>
            <div className="payment-row-left mr-auto color-primary f-22">
                <LeftOutlined />
            </div>
        </Row>;
    }

    function getRoroWalletCard() {
        return <Row className='payment-row py-1' onClick={(e) => paymentClick(e)}>
            <div className="payment-row-right">
                <img className='ml-1 payment-logo' src={walletLogo} alt="" />
                <div>
                    <Typography level={4} className='f-22  mt-0'> {'پرداخت با اعتبار'}</Typography>
                    <Typography level={5}
                        className='f-14  mt-0 color-primary'>
                        اعتبار موجود &nbsp;<Currency value={walletBalance} />
                    </Typography>
                </div>
            </div>
            <div className="payment-row-left mr-auto color-primary f-22">
                <LeftOutlined />
            </div>
        </Row>

    }

    return paymentGateway.paymentGatewayId === "RoroWalletPay" ? getRoroWalletCard() : getBankGatewayCard();
}

const mapStateToProps = state => ({
    walletBalance: selectWalletBalance(state),
})

export default connect(mapStateToProps)(PaymentCard)